import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import CertGroup from '../components/CertGroup';
import Grid from '../components/Grid';
import HR from '../components/HR';
import ParentTemplate from '../components/ParentTemplate';
import Text from '../components/Text';
import TextLink from '../components/TextLink';

import { StyledTextBody, MapLink, MapImg } from './styles';
import { mixins } from '../settings';

class DealerTemplate extends Component {
  static propTypes = {
    pageContext: PropTypes.shape({})
  };

  static defaultProps = {
    pageContext: {}
  };


  displayHours = (hours) => {
    const formattedHours = mixins.formatHours(hours);

    return formattedHours.map((timeArray) => {
      return (
        <div key={timeArray}>
          {timeArray.map((time) => (
            <StyledTextBody key={time} margins={false}>
              {time}
            </StyledTextBody>
          ))}
        </div>
      );
    });
  };

  renderLanguages = () => {
    const { pageContext } = this.props;
    const dealer = pageContext.data;
    const languages = dealer.dealerLanguagesSpoken;
    const langSpoken = mixins.formatLanguages(languages);

    if (langSpoken) {
      return (
        <Fragment>
          <HR />
          <Text.H3 color="grey2" transform="uppercase">
            Languages Spoken
          </Text.H3>
          <Text.Body>{mixins.formatLanguages(languages)}</Text.Body>
        </Fragment>
      );
    }
    return null;
  };

  componentDidMount() {
    let dataLayerObject = {
      dataLayerVersion: '1.0',
      page: {
        pageInfo: {
          pageName: 'nissanusa|seo_dealer_index|dealer_details',
          theme: 'seo_index_page'
        },
        category: {
          pageType: 'html',
          hierarchy1: 'nissanusa',
          hierarchy2: 'seo_dealer_index',
          hierarchy3: 'dealer_details',
          siteSection: 'seo',
          genPageName: 'seo_dealer_index_dealer_details'
        },
      },
      event: {
        accordion: {
          name: 'dealer-details-services-accordion',
          section: 'dealer-details',
          action: null
        }
      }
    };
    window.dtmTrackingDataLayer = dataLayerObject;
    window.googleDataLayer = [window.dtmTrackingDataLayer, { event: 'DLready' }];
  }


  render() {
    const { pageContext } = this.props;
    const dealer = pageContext.data;
    const stateName = pageContext.stateName;
    const stateURL = pageContext.stateURL;
    const dealerURL = pageContext.dealerURL;

    return (
      <ParentTemplate noStateList divId="dealer-details">
        <Fragment>
          {dealer ? (
            <Fragment>
              <Helmet>
                <title>
                  {mixins.properCase(dealer.dealerName)} Dealer in {mixins.properCase(dealer.dealerCityName)}, {stateName} | Nissan USA
              </title>
                <meta
                  name="description"
                  content={`Contact ${dealer.dealerName} for dealership & service hours, new & used inventory, vehicle parts, and special offers. Call ${dealer.dealerPhoneNumber} today.`}
                />
                <link rel="canonical" href={`https://www.nissanusa.com/nissandealers/location/${dealerURL}/`} />
              </Helmet>

              <a href={`/nissandealers/location/${stateURL}/`}>
                <BackButton />
              </a>
              <Text.H2 color="grey2" transform="uppercase">
                {dealer.dealerName}
              </Text.H2>
              <a href={`/buildyournissan/inventory/index?dealerId=${dealer.dealerId}&zipCode=${dealer.dealerZip}&next=SEO.dealer_index.inventory_search`} dtm-track="view-inventory-more"
                dtm-track-button-type="button">
                <Button margins>View Inventory</Button>
              </a>
              {dealer.isDealerContactable && (
                <Fragment>
                  <a
                    href={`https://www.nissanusa.com/apps/contactdealer?hdnDealerId=${
                      dealer.dealerId
                      }&next=locate_bottom.contact_dealer_detail&hdnActionState=noActionState&sourcePage=TXN%3ADLR%3A%3ADealerResults%3A%3ATXNDLRDealerResults&hdnDealerName=${encodeURI(dealer.dealerName)}&hdnDealerZip=${encodeURI(dealer.dealerZip)}&hdnDealerState=${encodeURI(
                        dealer.dealerStateCode
                      )}&hdnDealerCity=${dealer.dealerCityName.replace(/ /g, '+')}&hdnDealerPhone=${encodeURI(
                        dealer.dealerPhoneNumber
                      )}&hdnDealerStreet=${dealer.dealerAddressLine1.replace(/ /g, '+')}&hdnDealerEmail=${encodeURI(
                        dealer.dealerEmailAddress
                      )}&hdnDealerDistance=${encodeURI(dealer.dealerDistance)}&hdnDealerUrl=${encodeURI(
                        dealer.dealerWebsite
                      )}&next=SEO.dealer_index.contact_dealer`}
                    dtm-track="contact-dealer"
                    dtm-track-button-type="button"
                  >
                    <TextLink>Contact Dealer</TextLink>
                  </a>

                  <a href={`https://www.nissanusa.com/tools/test-drive/?dealerId=${dealer.dealerId}`} dtm-track="book-test-drive"
                    dtm-track-button-type="button">
                    <TextLink>Book a Test Drive</TextLink>
                  </a>
                </Fragment>
              )}
              {dealer.dealerExpressServiceUrl && (
                <a href={dealer.dealerExpressServiceUrl} dtm-track="schedule-service"
                  dtm-track-button-type="button">
                  <TextLink>Schedule Service</TextLink>
                </a>
              )}

              {dealer.dealerWebsite && (
                <a target="_blank" href={dealer.dealerWebsite} dtm-track="view-dealer"
                  dtm-track-button-type="button">
                  <TextLink>View Dealer Site</TextLink>
                </a>
              )}

              <HR />
              <Text.H3 color="grey2" transform="uppercase">
                Address
            </Text.H3>
              <Grid.Row>
                <Grid.Col sm={20} md={8}>
                  <MapLink href={`https://maps.google.com/?q=${dealer.dealerAddressLine1}, ${dealer.dealerCityName}, ${dealer.dealerStateCode} ${dealer.dealerZip}`} target="_blank">
                    <Text.Body transform="uppercase" margins={false}>
                      {dealer.dealerName}
                      <br />
                      {dealer.dealerAddressLine1}
                      <br />
                      {dealer.dealerAddressLine2 && (
                        <Fragment>
                          {dealer.dealerAddressLine2}
                          <br />
                        </Fragment>
                      )}
                      {dealer.dealerCityName}, {dealer.dealerStateCode} {dealer.dealerZip}
                    </Text.Body>
                  </MapLink>
                </Grid.Col>
                <Grid.Col sm={20} md={12} offset={{ md: 2 }}>
                  <MapLink href={`https://maps.google.com/?q=${dealer.dealerAddressLine1}, ${dealer.dealerCityName}, ${dealer.dealerStateCode} ${dealer.dealerZip}`} target="_blank">
                    <MapImg src={`https://maps.googleapis.com/maps/api/staticmap?size=640x420&markers=size:mid%7Ccolor:red%7C${dealer.dealerLatitude},${dealer.dealerLongitude}&key=AIzaSyCyFX-wepwszeSovK5oTzMyCUqj2Jviaqo`} alt="" />
                  </MapLink>
                </Grid.Col>
              </Grid.Row>



              <HR />
              <Text.H3 color="grey2" transform="uppercase">
                Phone Numbers
            </Text.H3>

              <Grid.Row>
                {dealer.dealerPhoneNumber && (
                  <Grid.Col xs={24} lg={8}>
                    <Text.Body>
                      <Text.Body tag="span" font="bold">
                        Main Line{' '}
                      </Text.Body>
                      {dealer.dealerPhoneNumber}
                    </Text.Body>
                  </Grid.Col>
                )}

                {dealer.dealerSalesPhone && (
                  <Grid.Col xs={24} lg={8}>
                    <Text.Body>
                      <Text.Body tag="span" font="bold">
                        Internet Sales{' '}
                      </Text.Body>
                      {dealer.dealerSalesPhone}
                    </Text.Body>
                  </Grid.Col>
                )}

                {dealer.dealerServicePhone && (
                  <Grid.Col xs={24} lg={8}>
                    <Text.Body>
                      <Text.Body tag="span" font="bold">
                        Service{' '}
                      </Text.Body>
                      {dealer.dealerServicePhone}
                    </Text.Body>
                  </Grid.Col>
                )}
              </Grid.Row>

              {dealer.dealerSalesHours && (
                <Fragment>
                  <HR />
                  <Text.H3 color="grey2" transform="uppercase">
                    Sales Hours
                </Text.H3>
                  {this.displayHours(dealer.dealerSalesHours)}
                </Fragment>
              )}

              {dealer.dealerServiceHours && (
                <Fragment>
                  <HR />
                  <Text.H3 color="grey2" transform="uppercase">
                    Service Hours
                </Text.H3>
                  {this.displayHours(dealer.dealerServiceHours)}
                </Fragment>
              )}

              {this.renderLanguages()}

              <HR />
              <Text.H3 color="grey2" transform="uppercase">
                Nissan Services & Certifications
            </Text.H3>

              {/** Services & Certifications Dropdown group */}
              <CertGroup dealer={dealer} />

              <a href={`/nissandealers/location/${stateURL}/`}>
                <BackButton />
              </a>
            </Fragment>
          ) : (
              <Text.H3>NO DEALER INFORMATION AVAILABLE</Text.H3>
            )}
        </Fragment>
      </ParentTemplate>

    );
  }
}


export default DealerTemplate;
